import { isStringEmpty } from '@monash/portal-frontend-common';

export const bySearch = (search) => (link) => {
  if (!search) return true;

  const { description, name, url, tags } = link;

  const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

  const searchUrls = search.match(URL_REGEX);
  const searchWithoutUrls = search
    .replace(URL_REGEX, '')
    .replace(/\s+/g, ' ')
    .trim();

  const searchTerms = isStringEmpty(searchWithoutUrls)
    ? []
    : searchWithoutUrls
        .replace(/[^a-zA-Z ]/g, ' ')
        .trim()
        .split(' ');

  const everyTermMatches =
    searchTerms.length &&
    searchTerms.every((term) => {
      const normalisedTerm = term.toLowerCase();

      return (
        description?.toLowerCase()?.includes(normalisedTerm) ||
        name?.toLowerCase()?.includes(normalisedTerm) ||
        url?.toLowerCase()?.includes(normalisedTerm) ||
        tags?.some((tag) => tag.toLowerCase().includes(normalisedTerm))
      );
    });

  const simplifiedSearchUrls = searchUrls?.map((searchUrl) =>
    searchUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
  );

  const someUrlMatches = simplifiedSearchUrls?.some((searchUrl) =>
    url?.toLowerCase()?.includes(searchUrl.toLowerCase())
  );

  return everyTermMatches || someUrlMatches;
};
